import { create } from 'zustand';

export const VALID_CAMPAIGNS = ['propeller_a', 'propeller_b'] as const;

export type CampaignId = (typeof VALID_CAMPAIGNS)[number];

export function isCampaignId(value: string | null): value is CampaignId {
	return VALID_CAMPAIGNS.includes(value as CampaignId);
}

const log = console.log.bind(console, '[useCampaignStore]:');

type State = {
	campaignId: CampaignId | null;
	campaignModalClosedTime: number | null;
	completedOffersCount: number;
	countCampaignPopupTimesClosed: number;
	isCampaignGoalAchieved: boolean;
	isOngoingTimeout: boolean;
	isReachedMainPage: boolean;
	lastCompletedOfferEndTime: number | null;
};

type Action = {
	setCampaignId: (val: CampaignId | null) => void;
	setCampaignModalClosedTime: (val: number) => void;
	setCompletedOffersCount: (val: number) => void;
	setCountCampaignPopupTimesClosed: (val: number) => void;
	setIsCampaignGoalAchieved: (val: boolean) => void;
	setIsOngoingTimeout: (val: boolean) => void;
	setIsReachedMainPage: (val: boolean) => void;
	setLastCompletedOfferEndTime: (val: number) => void;
};

export const useCampaignStore = create<State & Action>((set) => ({
	campaignId: null,
	campaignModalClosedTime: null,
	completedOffersCount: 0,
	countCampaignPopupTimesClosed: 0,
	isCampaignGoalAchieved: false,
	isOngoingTimeout: false,
	isReachedMainPage: false,
	lastCompletedOfferEndTime: null,
	setCampaignId(val) {
		log('setCampaignId', val);
		set({ campaignId: val });
	},
	setCampaignModalClosedTime(val) {
		log('setCampaignModalClosedTime', val);

		set({ campaignModalClosedTime: val });
	},
	setCompletedOffersCount(val) {
		log('setCompletedOffersCount', val);

		set({ completedOffersCount: val });
	},
	setCountCampaignPopupTimesClosed(val) {
		log('setCountCampaignPopupTimesClosed', val);

		set({ countCampaignPopupTimesClosed: val });
	},
	setIsCampaignGoalAchieved(val) {
		log('setIsCampaignGoalAchieved', val);

		set({ isCampaignGoalAchieved: val });
	},
	setIsOngoingTimeout(val) {
		log('setIsOngoingTimeout', val);
		set({ isOngoingTimeout: val });
	},
	setIsReachedMainPage(val) {
		log('setIsReachedMainPage', val);

		set({ isReachedMainPage: val });
	},

	setLastCompletedOfferEndTime(val) {
		log('setLastCompletedOfferEndTime', val);

		set({ lastCompletedOfferEndTime: val });
	},
}));
